import { render, staticRenderFns } from "./EditFormPayment.vue?vue&type=template&id=22573a79&lang=pug"
import script from "./EditFormPayment.vue?vue&type=script&lang=js"
export * from "./EditFormPayment.vue?vue&type=script&lang=js"
import style0 from "./EditFormPayment.vue?vue&type=style&index=0&id=22573a79&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports